angular.module('tf.services')

    .factory('FarmService', ['HttpService','$q','UrlEncodingService','$stateParams','WebSocketService','$rootScope','Session','DemoFarmerService', 'NotificationService', '$state',
            function (HttpService, $q, UrlEncodingService, $stateParams, WebSocketService, $rootScope, Session, DemoFarmerService, NotificationService, $state) {
        var service = {};

        service.getAssets = function(){
            var defer = $q.defer();
            $rootScope.$broadcast('working',true);
            HttpService.get('farm/' + Session.farm._id + '/assets').then(function (response) {
                $rootScope.$broadcast('working',false);
                var assets = response.data;
                if(_.includes(['dok@tf.com'],Session.user.getEmail())) {
                    assets.push(DemoFarmerService.farmer);
                }
                defer.resolve(assets);
            });
            return defer.promise;

        };

        service.plan = function(){
            var defer = $q.defer();
            HttpService.get('farm/' + Session.farm._id + '/plan').then(function (response) {
                var plan = response.data;
                defer.resolve(plan);
            });
            return defer.promise;
        };

        service.getMembers = function(params){
            var defer = $q.defer();
            params = params || {};
            var query = _.extend({},params.role? {role : params.role} : {}, params.not? {not : params.not} : {});
            HttpService.get('farm/' + Session.farm._id + '/members', query).then(function (response) {
                var members = response.data;
                defer.resolve(members);
            });
            return defer.promise;
        };

        service.getGroups = function (params) {
            var defer = $q.defer();
            params = params || {};
            var query = _.extend({});
            HttpService.get('farm/' + Session.farm._id + '/groups', query).then(function (response) {
                var groups = response.data;
                defer.resolve(groups);
            });
            return defer.promise;
        };

        service.createGroup = function(group, members){
            var defer = $q.defer();
            HttpService.post('farm/' + Session.farm._id + '/groups', {group : group, members : members}).then(function (response) {
                var group = response.data;
                defer.resolve(group);
            });
            return defer.promise;
        };

        service.updateGroup = function(group){
            var defer = $q.defer();
            HttpService.post('group/' + group.id, {group : group}).then(function (response) {
                var group = response.data;
                defer.resolve(group);
            });
            return defer.promise;
        };

        service.deleteGroup = function(group){
            var defer = $q.defer();
            HttpService.post('group/' + group.id + '/delete').then(function (response) {
                defer.resolve();
            });
            return defer.promise;
        };

        service.getClusters = function(){
            var defer = $q.defer();
            HttpService.get('cluster').then(function (response) {
                var cluster = response.data;
                defer.resolve(cluster);
            });
            return defer.promise;
        };

        service.createCluster = function(cluster, farmers){
            var defer = $q.defer();
            HttpService.post('cluster', {cluster : cluster, farmers : farmers}).then(function (response) {
                var cluster = response.data;
                defer.resolve(cluster);
            });
            return defer.promise;
        };

        service.updateCluster = function(cluster){
            var defer = $q.defer();
            HttpService.post('cluster/' + cluster.id, {cluster : cluster}).then(function (response) {
                var cluster = response.data;
                defer.resolve(cluster);
            });
            return defer.promise;
        };

        service.deleteCluster = function(cluster){
            var defer = $q.defer();
            HttpService.post('cluster/' + cluster.id + '/delete').then(function (response) {
                defer.resolve();
            });
            return defer.promise;
        };


        service.getFarm = function(){
            var defer = $q.defer();
            HttpService.get('farm/' + Session.farm._id).then(function (response) {
                var farmers = response.data;
                defer.resolve(farmers);
            });
            return defer.promise;
        };

        service.getFarmers = function(){
            var defer = $q.defer();
            HttpService.get('farm/' + Session.farm._id + '/farmers').then(function (response) {
                var farmers = response.data;
                defer.resolve(farmers);
            });
            return defer.promise;
        };

        service.addFarmer = function(farmer){
            return HttpService.post('farm/' + Session.farm._id + '/farmers', {farmer : farmer});
        };
        service.updateFarmer = function(farmer){
            return HttpService.post('farm/' + Session.farm._id + '/farmers', {farmer : farmer});
        };
        service.deleteFarmer = function(farmer){
            return HttpService.post('farmer/delete', {farm: Session.farm._id, farmer: farmer});
        };
        service.disconnectFarmer = function(farmer){
            return HttpService.post('farmer/disconnect', {farm: Session.farm._id, farmer: farmer});
        };

        service.addMembers = function(emails,role, groups){
            return HttpService.post('farm/' + Session.farm._id + '/members', {emails : emails, role : role, groups : groups});
        };
        service.addMembersToGroup = function(emails,group){
            return HttpService.post('farm/' + Session.farm._id + '/groups/members', {emails : emails, group : group});
        };
        service.removeMemberFromGroup = function(user,group){
            return HttpService.post('farm/' + Session.farm._id + '/groups/members/delete', {user : user, group : group});
        };
        service.removeMember = function(user){
            return HttpService.post('farm/' + Session.farm._id + '/members/delete', {user : user});
        };
        service.saveMember = function(user, groups){
            return HttpService.post('farm/' + Session.farm._id + '/members', {user : user, groups : groups});
        };

        service.getOwner = function () {
            return HttpService.get('farm/' + Session.farm._id + '/owner');
        };

        service.checkAvailableFarmersQuota = function () {
            return HttpService.get('farm/' + Session.farm._id + '/available-farmers');
        };
        service.checkAvailableUsersQuota = function () {
            return HttpService.get('farm/' + Session.farm._id + '/available-users');
        };

        service.checkCanProduce = function () {
            return HttpService.get('farm/' + Session.farm._id + '/can-produce');
        };

        service.goToUpgrade = function (messagePrefix, analyticsParams) {
            if(Session.isFarmOwner()) {
                $state.go('app.subscribe.pricing', {analytics_params : analyticsParams || {}});
            }else{
                service.getOwner().then(function (res) {
                    var user = res.data;
                    var popupInfo = "the farm owner";
                    if(user) {
                        popupInfo = '<b>' + (user.local.first_name ? user.full_name : "") + '</b>' +
                            '<br/>e-mail:  <a href=\"mailto:' + user.local.email + '\">' + user.local.email + '</a>';
                    }
                    NotificationService.popup('info-popup', {
                        content : messagePrefix + ' ' + popupInfo
                    });
                });
            }
        };

        service.openFarmerSettings= function(farmer, cb) {
            farmer = farmer || {};
            NotificationService.modal({
                animation: true,
                templateUrl: 'js/components/farmerSettings/farmer-settings.html',
                controller: 'FarmerSettingsController',
                size: 'lg',
                windowTopClass : 'farmer-settings-modal',
                backdrop : 'static',
                keyboard : false,
                resolve: {
                    farmer: farmer
                }
            }, cb);
        };

        service.openFarmerClusterSettings= function(cluster, cb) {

            NotificationService.modal({
                animation: true,
                templateUrl: 'js/components/createCluster/create-cluster.html',
                controller: 'CreateClusterController',
                size: 'lg',
                windowTopClass : 'farmer-cluster-modal',
                backdrop : 'static',
                keyboard : false,
                resolve: {
                    cluster: cluster
                }
            }, cb);
        };


        service.openMemberSettings= function(user, farm, cb) {

            NotificationService.modal({
                animation: true,
                templateUrl: 'js/components/memberSettings/member-settings.html',
                controller: 'MemberSettingsController',
                size: 'lg',
                windowTopClass : 'farmer-settings-modal',
                backdrop : 'static',
                keyboard : false,
                resolve: {
                    user: user,
                    farm : farm
                }
            }, cb);
        };

        service.openAddMembersPopup= function(farm, cb) {

            NotificationService.modal({
                animation: true,
                templateUrl: 'js/components/addMembers/addMembers.html',
                controller: 'AddMembersController',
                size: 'lg',
                windowTopClass : 'add-members-modal',
                backdrop : 'static',
                keyboard : false,
                resolve : {
                    farm : farm
                }
            }, cb);
        };

        service.openCreateGroupPopup= function(farm, cb) {

            NotificationService.modal({
                animation: true,
                templateUrl: 'js/components/createGroup/create-group.html',
                controller: 'CreateGroupController',
                size: 'lg',
                windowTopClass : 'create-group-modal',
                backdrop : 'static',
                keyboard : false,
                resolve : {
                    farm : farm
                }

            }, cb);
        };

        service.openManageGroupPopup= function(group, cb) {

            NotificationService.modal({
                animation: true,
                templateUrl: 'js/components/manageGroup/manage-group.html',
                controller: 'ManageGroupController',
                size: 'lg',
                windowTopClass : 'manage-group-modal',
                backdrop : 'static',
                keyboard : false,
                resolve : {
                    group : group
                }

            }, cb);
        };

        service.updateFarmerVersion = function(farmer){
            HttpService.post('farmer/' + farmer.key + '/update');
        };


        return service;
    }]);
